export const FLITCH_APPROVAL_REQUEST = "FLITCH_APPROVAL_REQUEST";
export const FLITCH_APPROVAL_SUCCESS = "FLITCH_APPROVAL_SUCCESS";
export const FLITCH_APPROVAL_FAILED = "FLITCH_APPROVAL_FAILED";
